// extracted by mini-css-extract-plugin
module.exports = {"borderBottom":"SidebarAccordion_borderBottom__ycFYa","buttonContainer":"SidebarAccordion_buttonContainer__BBu2G","body":"SidebarAccordion_body__7H5Su"};